import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/nyhet1.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://soundcloud.com/user-688920568-653173414"
}, [
  /*#__PURE__*/_createElementVNode("button", { class: "button_lol" }, [
    /*#__PURE__*/_createElementVNode("span", null, "SOUNDCLOUD")
  ]),
  /*#__PURE__*/_createElementVNode("iframe", {
    allowtransparency: "true",
    scrolling: "no",
    frameborder: "no",
    src: "https://w.soundcloud.com/icon/?url=http%3A%2F%2Fsoundcloud.com%2Fuser-688920568-653173414&color=orange_white&size=64",
    style: {"width":"64px","height":"64px"}
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://t.me/tallrik"
}, [
  /*#__PURE__*/_createElementVNode("button", { class: "button" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Follow the fekking Telegram!!!"),
    /*#__PURE__*/_createElementVNode("iframe", {
      id: "webroundbuttonwidget3",
      file: "webroundbuttonwidget",
      src: "https://telegrambutton.com/webroundbuttonwidget.php?chat_id=tallrik&showchatid=true&showmembercount=true&showmembercount=true&color=&pulse=true&textcolor=white&shadowval=&textval=join channel",
      border: "1",
      style: {"border":"20px","height":"100px","width":"100px"}
    })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "blink_1" }, "NEWS (NYHETER)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Breaking: Døner Tallrik & Dj Bord har fått penger fra NAV.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { style: {"font-style":"italic"} }, "\"Dette er stor sak i Trøgstad og mange er glade. Bedre med penger fra staten en brødskive uten servelaten\" - Trøgstadværing", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"15em"},
  alt: "Vue logo",
  src: _imports_0
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { style: {"font-style":"italic"} }, "\"Bilde: Kvittering på at vi får spenna (Ikke til å bruke sjæl)", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, "Mining Bitcoins", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!
  const _component_vue3_autocounter = _resolveComponent("vue3-autocounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HelloWorld, { msg: "Døner Tallrik & DJ Bord" }),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _createElementVNode("h2", null, [
      _createVNode(_component_vue3_autocounter, {
        ref: "counter",
        startAmount: 0,
        endAmount: 10000000000000000000000,
        duration: 1000,
        prefix: "$",
        suffix: "USD",
        separator: ",",
        decimalSeparator: ".",
        decimals: 2,
        autoinit: true,
        onFinished: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alert(`Counting finished!`)))
      }, null, 512)
    ]),
    _createElementVNode("div", {
      class: "lol",
      id: "r1k1",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trykk($event, ['r1k2','r3k1'])))
    }, "3"),
    _createElementVNode("div", {
      class: "lol",
      id: "r1k2",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trykk($event, ['r1k1','r2k2', 'r1k3'])))
    }, "2"),
    _createElementVNode("div", {
      class: "lol",
      id: "r1k3",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trykk($event, ['r1k2','r2k3'])))
    }, "1"),
    _createElementVNode("div", {
      id: "r2k1",
      class: "forstPaLinja lol",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trykk($event, ['r1k1', 'r2k2', 'r3k1'])))
    }, "7"),
    _createElementVNode("div", {
      class: "lol",
      id: "r2k2",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.trykk($event, ['r1k2', 'r2k1', 'r2k3', 'r3k2'])))
    }),
    _createElementVNode("div", {
      class: "lol",
      id: "r2k3",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trykk($event, ['r1k3', 'r2k2', 'r3k3'])))
    }, "4"),
    _createElementVNode("div", {
      id: "r3k1",
      class: "forstPaLinja lol",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trykk($event, ['r2k1', 'r3k2'])))
    }, "8"),
    _createElementVNode("div", {
      class: "lol",
      id: "r3k2",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trykk($event, ['r3k1', 'r2k2', 'r3k3'])))
    }, "5"),
    _createElementVNode("div", {
      class: "lol",
      id: "r3k3",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trykk($event, ['r3k2', 'r2k3'])))
    }, "6"),
    _createElementVNode("iframe", {
      onMouseover: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.mouseover && _ctx.mouseover(...args))),
      id: "webroundbuttonwidget2",
      file: "webroundbuttonwidget",
      src: "https://telegrambutton.com/webroundbuttonwidget.php?chat_id=tallrik&showchatid=true&showmembercount=true&showmembercount=true&color=&pulse=true&textcolor=white&shadowval=&textval=join channel",
      border: "1",
      style: {"border":"20px","height":"100px","width":"100px"}
    }, null, 32)
  ]))
}